import { DefaultHttpClient } from './_default_http_client.js';
export function createHttpClient(options) {
    return new DefaultHttpClient(options);
}
export const http = createHttpClient();
//# sourceMappingURL=http.js.map